export default __webpack_public_path__ + "static/media/skype.152353b8.svg";